import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import AdbIcon from "@material-ui/icons/Adb";
import { Playground, Props } from "docz";
import { MenuItem } from "../index";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "menu-item"
    }}>{`Menu Item`}</h1>
    <p>{`Base on `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/menu-item/#menuitem-api"
      }}>{`https://material-ui.com/api/menu-item/#menuitem-api`}</a></p>
    <p>{`Icon`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://material-ui.com/components/material-icons/"
        }}>{`https://material-ui.com/components/material-icons/`}</a></li>
    </ul>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <h3 {...{
      "id": "basic"
    }}>{`Basic`}</h3>
    <Playground __position={0} __code={'<MenuItem selected name=\"name of menu item\" />\n<br />\n<MenuItem\n  selected\n  onClick={() => console.log(\'click item\')}\n  name=\"name of menu item\"\n  description=\"description\"\n  icon={<AdbIcon />}\n/>'} __scope={{
      props,
      DefaultLayout,
      AdbIcon,
      Playground,
      Props,
      MenuItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MenuItem selected name='name of menu item' mdxType="MenuItem" />
  <br />
  <MenuItem selected onClick={() => console.log('click item')} name='name of menu item' description='description' icon={<AdbIcon mdxType="AdbIcon" />} mdxType="MenuItem" />
    </Playground>
    <h3 {...{
      "id": "disable-padding"
    }}>{`Disable padding`}</h3>
    <Playground __position={1} __code={'<MenuItem selected name=\"name of menu item\" justContent disableHover />'} __scope={{
      props,
      DefaultLayout,
      AdbIcon,
      Playground,
      Props,
      MenuItem,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <MenuItem selected name='name of menu item' justContent disableHover mdxType="MenuItem" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={MenuItem} table mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      